import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fakeFiller',
})
export class FakeFillerPipe implements PipeTransform {
  transform(
    value: any[],
    nbItems: number = 10,
    type: string = 'object'
  ): any[] {
    if (Array.isArray(value) && value.length === 0) {
      let item = {};
      switch (type) {
        case 'number':
          item = 1;
          break;
        case 'boolean':
          item = true;
          break;
        case 'string':
          item = '';
          break;
        default:
          break;
      }
      return new Array(nbItems).fill(item);
    }

    return value;
  }
}
